export enum FDXMeasureCategory {

    NormalRoomUsage = 1,
    FollowingIncident = 2,
    BeforeWork = 3,
    PreliminaryWork = 4,
    DuringWorkOperator = 5,
    DuringWorkEnvironmental = 6,
    PostWork = 7,
    EndOfAsbestosWork = 8,
    EndOfAsbestosWork2 = 9,
    EndOfAsbestosProcessingWork = 10
}